import React from "react";
import { useSelector } from "react-redux";
import { selectCurrentBreakpoint } from "./layoutSlice";
import styles from "./TabletGuard.module.scss";

const TabletGuard = ({ children }: { children: React.ReactNode }) => {
  const breakpoint = useSelector(selectCurrentBreakpoint);
  const allowedBreakpoints = ["sm", "md"];

  // Don't render error if breakpoint is undefined/null or matches allowed breakpoints
  if (!breakpoint || allowedBreakpoints.includes(breakpoint)) {
    return <>{children}</>;
  }

  return (
    <div className={styles.container}>
      <p>
        Your screen is too {breakpoint === "xs" ? "small" : "big"}, please use a
        tablet.
      </p>
    </div>
  );
};

export default TabletGuard;
